import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { GatewayUpdateState } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<
      unknown,
      Error,
      { gatewayId: number; payload: GatewayUpdateState },
      unknown
    >,
    'mutationKey' | 'mutationFn'
  >
}

export const usePatchGatewayRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { gatewayId: number; payload: GatewayUpdateState }, unknown>(
    [Entities.Gateway, 'patch'],
    async ({ gatewayId, payload }) => {
      const { data } = await api.v1AdminGatewaysGatewayIdPatch(gatewayId, payload)
      return data
    },
    { ...options }
  )
}
